import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { OrderDetail } from './OrderDetail';
import { OrderList } from './OrderList';

export const Order = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/list`} component={OrderList} />
    <Route path={`${props.match.path}/:id`} component={OrderDetail} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/order/Order.tsx